import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue'
import { useRoute } from 'vue-router'

import PATHS from '@/router/paths'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'
import EmptyList from '@/components/EmptyList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ComingSoon',
  setup(__props) {

const route = useRoute()
const headerStore = useHeaderStore()

onMounted(() => {
  const pageTitle = (route.meta.pageTitle as string) || 'Políticas'
  headerStore.setTitle(pageTitle, '', { label: 'Políticas', route: PATHS.POLICIES_HOME })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(EmptyList, {
      title: "Em construção",
      class: "py-12"
    })
  ]))
}
}

})